import strings from "../../../../global/constants/StringConstants";
import urls from "../../../../global/constants/UrlConstants";
import { globalEmitter } from "../../../../utils/emitter";
import {
  getCallParams,
  makeCall,
  makeCallFile,
} from "../../../../utils/service";

export const fetchDetails = async (profileData: any) => {
  try {
    const callParams = await getCallParams("POST", profileData);
    const response = await makeCall(urls.fetchDetails, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getReportData = async (payload: any, language: string) => {
  try {
    const body = {
      data: payload,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCallFile(
      `${urls.getReport}/${language}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getFullReport = async (body: any, language: string) => {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCallFile(
      `${urls.getFullReport}/${language}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getShortResume = async (body: any, language: string) => {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCallFile(
      `${urls.getShortResume}/${language}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getReportByProfileId = async (
  profileId: string,
  payload: any,
  language: string,
  isDataTab: boolean,
  d1?: boolean,
  d10?: boolean,
  book?: number,
) => {
  try {
    const body = {
      data: payload,
    };
    const protocol = isDataTab ? "POST" : "GET";
    const initialUrl = isDataTab ? urls.getReport : urls.getFullReport;
    let url = `${initialUrl}/profile/${profileId}/lang/${language}`;
    if (!isDataTab) {
      if (Number(book)) {
        url += `/${book}`;
      }
      if (d1 !== undefined || d10 !== undefined) {
        const params = new URLSearchParams();
        if (d1 !== undefined) params.set("d1_rashi", String(d1));
        if (d10 !== undefined) params.set("d10_rashi", String(d10));
        url += `?${params.toString()}`;
      }
    }
    const callParams = isDataTab
      ? await getCallParams(protocol, body)
      : await getCallParams(protocol);
    const response = await makeCallFile(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getShortReport = async (
  profileId: string,
  payload: any,
  language: string,
  isDataTab: boolean,
  d1?: boolean,
  d10?: boolean,
) => {
  try {
    const body = {
      data: payload,
    };
    const protocol = isDataTab ? "POST" : "GET";
    const initialUrl = isDataTab ? urls.getShortResume : urls.getFullResume;
    let url = `${initialUrl}/profile/${profileId}/lang/${language}`;
    if (!isDataTab && (d1 !== undefined || d10 !== undefined)) {
      const params = new URLSearchParams();
      if (d1 !== undefined) params.set("d1_rashi", String(d1));
      if (d10 !== undefined) params.set("d10_rashi", String(d10));
      url += `?${params.toString()}`;
    }
    const callParams = isDataTab
      ? await getCallParams(protocol, body)
      : await getCallParams(protocol);
    const response = await makeCallFile(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const exportPdf = async (htmlContent: string) => {
  try {
    const body = {
      data: htmlContent,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCallFile(`${urls.exportPdf}`, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const exportPdfDirectDownload = async (
  htmlContent: string,
  fileName: string,
  withBackground: boolean = true,
) => {
  const { store } = await import("../../../../utils/store");
  const accessToken = store.getState().auth.accessToken;
  (async () => {
    try {
      const response = await fetch(urls.exportPdf, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          data: htmlContent,
          with_background: withBackground,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `HTTP error! status: ${response.status}, message: ${errorText}`,
        );
      }
      if (response.body && typeof ReadableStream !== "undefined") {
        const reader = response.body.getReader();
        const chunks: Uint8Array[] = [];
        let receivedLength = 0;
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          chunks.push(value);
          receivedLength += value.length;

          if (receivedLength % (1024 * 1024) < value.length) {
            await new Promise((resolve) => setTimeout(resolve, 0));
          }
        }

        const allChunks = new Uint8Array(receivedLength);
        let position = 0;
        for (const chunk of chunks) {
          allChunks.set(chunk, position);
          position += chunk.length;
        }

        const blob = new Blob([allChunks], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName ? `${fileName}.pdf` : "document.pdf";
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          setTimeout(() => window.URL.revokeObjectURL(url), 100);
        }, 100);
      } else {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName ? `${fileName}.pdf` : "document.pdf";
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          setTimeout(() => window.URL.revokeObjectURL(url), 100);
        }, 100);
      }
    } catch (error: any) {
      globalEmitter.emit(strings.notification, {
        type: strings.error,
        message: "Failed to download PDF. Please try again.",
        title: "Download Error",
      });
    }
  })();

  return Promise.resolve();
};
